import type { Asset, AssetType } from "@/lib/assets";

/** Very High -> Low, for ranking business-importance ties in sorted lists.
 * Shared by ByAssetView and ByHazardView so both order ties consistently. */
export const IMPORTANCE_ORDER: Record<1 | 2 | 3 | 4, number> = { 4: 0, 3: 1, 2: 2, 1: 3 };

/** This asset's display type name — its custom name if set, else its
 * asset-type catalog name. Shared by ByAssetView and ByHazardView for the
 * asset subline. */
export function assetTypeName(asset: Asset, assetTypes: AssetType[]): string {
  if (asset.customAssetTypeName) return asset.customAssetTypeName;
  return assetTypes.find((t) => t.id === asset.assetTypeId)?.name ?? "Unknown type";
}
